var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebappStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Driver-on-the-way(Share-ETA)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Track-Driver---Go-full-receipt",
    transform: "translate(-1345.000000, -771.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1345.000000, 771.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    rx: 3.91959799
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop-outline-copy",
    transform: "translate(9.949749, 8.743719)",
    fill: "#0E730F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4170854,23.4798995 C35.2550251,23.4798995 36.758794,21.9704774 36.758794,20.1256281 L36.758794,3.35427136 C36.758794,1.50942211 35.2550251,0 33.4170854,0 L6.68341709,0 C4.84547739,0 3.34170854,1.50942211 3.34170854,3.35427136 L3.34170854,20.1256281 C3.34170854,21.9704774 4.84547739,23.4798995 6.68341709,23.4798995 L1.67713568,23.4798995 C0.75087922,23.4798995 -1.13433701e-16,24.2307787 0,25.1570352 L0,25.1570352 C1.13433701e-16,26.0832916 0.75087922,26.8341709 1.67713568,26.8341709 L38.4233668,26.8341709 C39.3496233,26.8341709 40.1005025,26.0832916 40.1005025,25.1570352 L40.1005025,25.1570352 C40.1005025,24.2307787 39.3496233,23.4798995 38.4233668,23.4798995 L33.4170854,23.4798995 Z M6.68341709,3.35427136 L33.4170854,3.35427136 L33.4170854,20.1256281 L6.68341709,20.1256281 L6.68341709,3.35427136 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Try-it-on-our-Copy",
    fontFamily: "Roboto-Light, Roboto",
    fontSize: 4.52261307,
    fontWeight: 300,
    fill: "#0E730F"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17.4874372,
    y: 43.798995
  }, "Try it on our")), /*#__PURE__*/React.createElement("text", {
    id: "Web-App-Copy",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 10.5527638,
    fontWeight: "normal",
    fill: "#0E730F"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.34673367,
    y: 54.321608
  }, "Web App")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebappStore);
export default __webpack_public_path__ + "static/media/webapp_store.d80bc79b0de63d87bf238a44e7dfd3ab.svg";
export { ForwardRef as ReactComponent };